module.exports = __webpack_public_path__ + "img/Image Slider.2d341c06.png";